import { Widget, WidgetType } from '../../schema/widgets/Widget';
import { IRootWidget } from '../../schema/widgets/repository/containers/root/IRootWidget';

export interface IWidgetsPage {
  pageIndex: number;
  sectionIndex: number;
  widgets: Widget[];
}

/**
 * Divide i widget in pagine, in base ai widget di tipo Page.
 */
export function getPagesInRoot(
  root: IRootWidget | null | undefined,
  sectionIndex: number,
) {
  if (!root?.children) return [];

  const pages: IWidgetsPage[] = [];
  let page: IWidgetsPage = { pageIndex: 0, sectionIndex, widgets: [] };

  for (const widget of root.children) {
    if (widget.type === WidgetType.Page) {
      pages.push(page);
      page = { pageIndex: page.pageIndex + 1, sectionIndex, widgets: [] };
      continue;
    }

    page.widgets.push(widget);
  }

  // Aggiungo l'ultima pagina se non è vuota (o se è l'unica pagina)
  if (page.widgets.length > 0 || page.pageIndex === 0) {
    pages.push(page);
  }

  return pages;
}
